@if (visible$ | async) {
    <fieldset [formGroup]="optionGroup">
        <ng-container *ngrxLet="optionFunctionalElement$; let optionFunctionalElement">
            <div class="row">
                <p class="col" [innerHTML]="optionFunctionalElement.label"></p>
            </div>
            @if (optionFunctionalElement.choices) {
                <pace-forms-choices [choices]="choices$ | async" [formControl]="radioInputControl"></pace-forms-choices>
            }
        </ng-container>
    </fieldset>
}
